(function ($) {

        jQuery.fn.makeActive = function () {
            var $this = this;
            var toggle = $this.data('active-toggle');
            var $dataTarget = $this.data('active-target');
            $dataTarget = $($dataTarget);
            if (toggle === 'tab') {
                $dataTarget.tab('show');
            }
        }
    }
)(jQuery);

$('.make-active').makeActive();